export default __webpack_public_path__ + "static/media/logo-rtl-dark.165abd31.svg";